export const setTabsAccToAcl = (data, aclData) => {
  let arr = [];
  data &&
    data?.map((val, i) => {
      if (aclData.includes(val.aclValue)) {
        arr.push(val);
      }
    });
  return arr;
};
